var _clipPath, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTwoSpace = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 25,
  height: 25,
  fill: "none",
  viewBox: "0 0 25 25"
}, props), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
  id: "two-space_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  d: "M.616.183h24v24h-24z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  stroke: "currentColor",
  strokeWidth: 1.5,
  clipPath: "url(#two-space_svg__a)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 10.521,
  height: 7.315,
  x: 7.356,
  y: 3.717,
  rx: 0.853
}), /*#__PURE__*/React.createElement("rect", {
  width: 10.521,
  height: 7.315,
  x: 7.356,
  y: 13.333,
  rx: 0.853
}))));
export { SvgTwoSpace as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyBmaWxsPSJub25lIiBoZWlnaHQ9IjI1IiB2aWV3Qm94PSIwIDAgMjUgMjUiIHdpZHRoPSIyNSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+PGNsaXBQYXRoIGlkPSJhIj48cGF0aCBkPSJtLjYxNjIxMS4xODI2MTdoMjR2MjRoLTI0eiIvPjwvY2xpcFBhdGg+PGcgY2xpcC1wYXRoPSJ1cmwoI2EpIiBzdHJva2U9ImN1cnJlbnRDb2xvciIgc3Ryb2tlLXdpZHRoPSIxLjUiPjxyZWN0IGhlaWdodD0iNy4zMTUxMyIgcng9Ii44NTI3NTEiIHdpZHRoPSIxMC41MjA2IiB4PSI3LjM1NTgzIiB5PSIzLjcxNjgiLz48cmVjdCBoZWlnaHQ9IjcuMzE1MTMiIHJ4PSIuODUyNzUxIiB3aWR0aD0iMTAuNTIwNiIgeD0iNy4zNTU4MyIgeT0iMTMuMzMzMyIvPjwvZz48L3N2Zz4=";